import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IAccountSettingsState {
}

const initialState: IAccountSettingsState = {
}

const accountSettingsSlice = createSlice({
    name: 'accountSettings',
    initialState,
    reducers: {
        teamAcceptInvitation(state, action: PayloadAction<{ invite_id: string; token: string; }>) {
            // no-op here, this action is used by a saga
        },
        teamAcceptInvitationSuccess(state) {
            // no-op here, this action is used by a saga
        },
        teamAcceptInvitationFailure(state, action: PayloadAction<string>) {
            // no-op here, this action is used by a saga
        },
    }
})

export default accountSettingsSlice;
